import {
  Tooltip as Root,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from '#/components/ui/tooltip';
import React, { ReactNode } from 'react';

let SIDE_OPTIONS: readonly ['top', 'right', 'bottom', 'left'];
type Side = (typeof SIDE_OPTIONS)[number];

interface TooltipProps {
  text: string | React.ReactNode;
  children: ReactNode;
  className?: string;
  delayDuration?: number;
  side?: Side;
}
export default function Tooltip({
  text,
  className,
  children,
  delayDuration = 300,
  side = 'top'
}: TooltipProps) {
  return (
    <TooltipProvider delayDuration={delayDuration}>
      <Root>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent className={`max-w-[40vw] ${className}`} side={side}>
          <div>{text}</div>
        </TooltipContent>
      </Root>
    </TooltipProvider>
  );
}
